import { ILecturerItem } from '../interfaces/Lecturer';

export const formatLecturerName = (person: ILecturerItem) => {
    if (!person) return;

    return `${person.titles.before_name ? `${person.titles.before_name} ` : ''}${person.name} ${person.surname}${
        person.titles.after_name ? ` ${person.titles.after_name}` : ''
    }`;
};
